import { IS_ELECTRON } from './config'

const noop = () => void 0

const isElectronEnvWrap = (fun) => {
  if (!IS_ELECTRON) {
    return noop
  }
  return fun
}

const getGlobal = isElectronEnvWrap((name) => {
  try {
    const remote = window.electron.remote
    return remote.getGlobal(name)
  } catch (error) {
    return void 0
  }
})

const getUserToken = isElectronEnvWrap(() => {
  return getGlobal('userToken')
})

const ipcSend = isElectronEnvWrap((name, chanel, params) => {
  window.ipcRenderer.send(name, chanel, params)
})

const ipcSendAction = isElectronEnvWrap((actionName, params) => {
  ipcSend('cocofax_action', actionName, params)
})

export { getUserToken, ipcSendAction }
